import * as React from "react";
import { useHistory, Link } from 'react-router-dom';
import {useState, useEffect} from 'react';
import axios from 'axios';

interface Props {
    ocationAd: any;
    DeviceID: any;
    ap: any;
    search: any;
    avisos: any;
}

const OcationItem: React.FC<Props> = ({ocationAd, DeviceID, ap, search, avisos}) => {
  const history = useHistory(); 
  const postImpressionClick = async() => {
    try {
        const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignID: ocationAd.CampaignID,
            MediaType: "click"
          };
          await axios.post("/impressions", {fields} );
    } catch (error) {
        
    }
}

  return (
    <div className="card">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-auto">
            {/* Image */}
            <Link to={{
            pathname: `/avisos/ad/${ocationAd.CampaignID}`,
            state:{
              campaign: ocationAd,
              DeviceID,
              ap,
              search,
              avisos
            }
          }}
          className="avatar avatar-lg" onClick={() => postImpressionClick()}>
              <img
                style={{
                    maxWidth: "100px",
                    maxHeight: "100px"
                }}
                src={`/google-storage/${encodeURIComponent(
                  ocationAd.CampaignDealItemURL
                )}`}
                alt="..."
                className="avatar-img rounded"
              />
            </Link>
          </div>
          <div className="col ml-n2">
            {/* Heading */}
            <h4 className="mb-1">
              {ocationAd.CampaignName}
            </h4>
            {/* Text */}
            <p className="small text-muted mb-1">
              {ocationAd.description}
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default OcationItem;
